import React, { useEffect, useState } from 'react'
import axios from 'axios'
import moment from 'moment'
import { saveAs } from 'file-saver'
import { Alert, Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

export default function AtkReportModal({ selectedDate, onClose }) {
  const [month, setMonth] = useState(moment(selectedDate).isValid() ? moment(selectedDate).format('YYYY-MM') : moment().format('YYYY-MM'))
  const [team, setTeam] = useState('')
  const [teams, setTeams] = useState([])
  const [loadingTeams, setLoadingTeams] = useState(true)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    let mounted = true
    axios
      .get('/teams')
      .then(({ data }) => {
        if (!data.success) throw new Error('teams')
        if (mounted) setTeams(data.data)
      })
      .catch(() => {
        if (mounted) setError('Lista e Teams nuk mund të ngarkohet. Mbyllni dhe provoni përsëri.')
      })
      .finally(() => {
        if (mounted) setLoadingTeams(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  const download = async () => {
    if (busy) return
    if (!moment(month, 'YYYY-MM', true).isValid()) {
      setError('Ju lutem zgjedhni muajin dhe vitin.')
      return
    }
    setBusy(true)
    setError('')
    try {
      const [year, selectedMonth] = month.split('-')
      const response = await axios.get('/salaries/atk-report', {
        params: { year, month: selectedMonth, ...(team ? { team } : {}) },
        responseType: 'blob'
      })
      if (!response.headers['content-type']?.includes('text/csv')) {
        const result = JSON.parse(await response.data.text())
        throw new Error(result.message || 'Raporti nuk mund të gjenerohet.')
      }
      const selectedTeam = teams.find((item) => item._id === team)
      const teamName = (selectedTeam?.name || '').replace(/[<>:"/\\|?*\x00-\x1f]/g, '_').trim()
      saveAs(response.data, `ATK_${year}_${selectedMonth}${teamName ? `_${teamName}` : ''}.csv`)
      onClose()
    } catch (failure) {
      let message = failure.message
      if (failure.response?.data instanceof Blob) {
        try {
          message = JSON.parse(await failure.response.data.text()).message
        } catch (_) {}
      }
      setError(message || 'Gabim gjatë shkarkimit të raportit. Provoni përsëri.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <Modal isOpen toggle={busy ? undefined : onClose} backdrop={busy ? 'static' : true} keyboard={!busy}>
      <ModalHeader toggle={busy ? undefined : onClose}>Eksporto raportin ATK</ModalHeader>
      <ModalBody>
        <p>Zgjedhni muajin dhe Team për raportin CSV. Përfshihen punonjësit e punësuar gjatë muajit, përfshirë hyrjet dhe largimet.</p>
        <p className='text-muted'>Fushat që mungojnë në HRM mbeten të zbrazëta në raport.</p>
        {error && <Alert color='danger'>{error}</Alert>}
        <FormGroup>
          <Label for='atk-month'>Muaji dhe viti:</Label>
          <Input id='atk-month' type='month' value={month} onChange={(event) => setMonth(event.target.value)} disabled={busy} />
        </FormGroup>
        <FormGroup>
          <Label for='atk-team'>Team</Label>
          <Input id='atk-team' type='select' value={team} onChange={(event) => setTeam(event.target.value)} disabled={busy || loadingTeams}>
            <option value=''>Të gjitha Teams</option>
            {teams.map((item) => (
              <option key={item._id} value={item._id}>
                {item.name}
              </option>
            ))}
          </Input>
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color='secondary' onClick={onClose} disabled={busy}>
          Anulo
        </Button>
        <Button color='info' onClick={download} disabled={busy || loadingTeams || !month}>
          {busy ? 'Duke gjeneruar...' : 'Eksporto ATK'}
        </Button>
      </ModalFooter>
    </Modal>
  )
}
